import { Injectable } from '@angular/core';
import { ApiClientProvider } from '../../../common';
import { IOrdersApiClient } from './i-orders-api.client';
import { OrdersApiClient } from './orders.api.client';
import { OrdersInMemoryApiClient } from './orders.api.inmemory.client';

@Injectable({
  providedIn: 'root'
})
export class OrdersApiClientProvider extends ApiClientProvider<IOrdersApiClient> {
  constructor(
    private client: OrdersApiClient,
    private inMemoryClient: OrdersInMemoryApiClient
  ) {
    super();
  }

  protected override getInMemoryClient(): IOrdersApiClient {
    return this.inMemoryClient;
  }
  protected override getApiClient(): IOrdersApiClient {
    return this.client;
  }
}
